import { render } from "./NavDesktop.vue?vue&type=template&id=5c01c3f7&scoped=true"
import script from "./NavDesktop.vue?vue&type=script&lang=ts"
export * from "./NavDesktop.vue?vue&type=script&lang=ts"

import "./NavDesktop.vue?vue&type=style&index=0&id=5c01c3f7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5c01c3f7"

export default script